import { default as localeCustomizations } from './locales'
import { default as containerCustomizations } from './customizations'
import { IPartnerConfig } from '../../internal'

import logoLight from './assets/bqt_logo.svg';
import logoDark from './assets/bqt_logo_dark_mode.svg';

// must export all of these for each partner. Empty if using defaults
const partnerCustomizations: IPartnerConfig = {
  assets: {
    logoOnBackground: logoLight,
    logoOnSecondary: logoLight,
    logoOnPrimary: logoLight,
    logoOnDark: logoDark
  },
  locales: localeCustomizations,
  containers: containerCustomizations,
}
export default partnerCustomizations;